import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTrigger,
  DialogClose,
} from "@/components/ui/dialog";
import { useState } from "react";

import PaidConsultationForm from "./Form/PaidConsultationForm";
import { useTranslate } from "@/components/base/providers/TranslateProv";

const PaidConsultationData = ({
  selectedTimeId,
  selectedDateId,
  data,
  children,
}: {
  selectedTimeId: any;
  selectedDateId: any;
  data: any;
  children: any;
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { locale } = useTranslate();
  return (
    <>
      <Dialog open={isModalOpen} onOpenChange={setIsModalOpen}>
        <DialogTrigger asChild>{children}</DialogTrigger>

        <DialogContent className="mx-auto max-w-4xl overflow-y-auto overflow-x-hidden max-h-screen">
          <DialogHeader>
            <h1 className="text-center text-lg md:text-xl">
              {locale === "ar"
                ? "معلومات ستفيدنا للرد عليك وتجهيز لك ما تحتاجه"
                : "Information that will help us respond to you and prepare what you need"}{" "}
            </h1>
            <DialogClose onClick={() => setIsModalOpen(false)} />
          </DialogHeader>

          {/* form */}
          <PaidConsultationForm
            selectedTimeId={selectedTimeId}
            selectedDateId={selectedDateId}
            data={data}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default PaidConsultationData;
